'use strict'

const taskSiteStates = {
  NEW: 'Noch nicht bestätigte Standorte',
  ACCEPTED: 'Aktive Standorte',
}

export function taskSiteStateFilter() {
  return function (state) {
    return taskSiteStates[state]
  }
}



// WEBPACK FOOTER //
// ./app/tasksites/filters/tasksite-state.filter.js